import { gql } from '@apollo/client';

/**
 * CREATE_STATEMENT_PDF_MUTATION
 * 
 * Creates a PDF statement for a monthly statement
 * 
 * @param id - The statement ID (integer)
 * 
 * @returns PDF data containing URL and expiration date
 */
export const CREATE_STATEMENT_PDF_MUTATION = gql`
	mutation CreateStatementPdf($id: Int!) {
		createStatementPdf(input: { id: $id }) {
			pdfData {
				url
				expirationDate
			}
		}
	}
`;
